const binding = { modules: {}, dataActions: {} };

    (binding.modules['ecomm-content-template-2'] = {
        c: () => require('partner/modules/ecomm-content-template-2/ecomm-content-template-2.tsx'),
        $type: 'contentModule',
        da: [],
        
        iNM: false,
        ns: '__local__',
        n: 'ecomm-content-template-2',
        p: '__local__',
        
        pdp: '',
        
        
        md: 'src/modules/ecomm-content-template-2'
    });
        

        
    window.__bindings__ = window.__bindings__ || {};
    window.__bindings__.modules = {
        ...window.__bindings__.modules || {},
        ...binding.modules
    };
    
        window.__bindings__.dataActions = {
        ...window.__bindings__.dataActions || {},
        ...binding.dataActions
    };
                        export const viewDictionary = {};
                        viewDictionary['__local__|__local__|modules|ecomm-content-template-2|ecomm-content-template-2'] = {
                c: () => require('partner/modules/ecomm-content-template-2/ecomm-content-template-2.view.tsx'),
                cn: '__local__-__local__-ecomm-content-template-2'
            };
window.__bindings__ = window.__bindings__ || {};
window.__bindings__.viewDictionary = {
                        ...window.__bindings__.viewDictionary || {},
                        ...viewDictionary
                    };